import { useState } from 'react';

type PayoutDetails = Readonly<{
  firstName: string;
  lastName: string;
  countryCode: string;
}>;

export const usePayoutDetailsConfirmation = ({ firstName, lastName, countryCode }: PayoutDetails) => {
  const [confirmedCountryCode, setConfirmedCountryCode] = useState<string>();
  const isConfirmed = confirmedCountryCode === countryCode;
  const hasLegalName = !!firstName.trim() && !!lastName.trim();

  return {
    isConfirmed,
    canSave: isConfirmed && hasLegalName,
    onConfirmedChange: (checked: boolean) => setConfirmedCountryCode(checked ? countryCode : undefined),
  };
};
